import { CirclePlus } from "lucide-react";
import React from "react";

import { IgPaper } from "@intelligems/ig-theme/IgPaper";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";

interface CreateNewCustomEventBigButtonProps {
  onClick: () => void;
}

export const CreateNewCustomEventBigButton = ({
  onClick,
}: CreateNewCustomEventBigButtonProps) => {
  const theme = useTheme();
  return (
    // Create new metric no existing metrics
    <Grid container marginTop={"30px"}>
      <IgPaper
        sx={{
          boxShadow: "none",
          borderRadius: "5px",
          "&:hover": {
            cursor: "pointer",
            border: `1px solid ${theme.igBorders.accent.default}`,
            backgroundColor: theme.igPrimitives.gray[200],
          },
        }}
        onClick={onClick}
      >
        <Grid
          container
          direction={"column"}
          alignItems={"center"}
          paddingLeft={"40px"}
          paddingRight={"40px"}
          paddingBottom={"20px"}
          paddingTop={"10px"}
        >
          <Grid>
            <CirclePlus size={36} />
          </Grid>
          <Grid>
            <IgTypography fontWeight={600}>
              Create New Custom Metric
            </IgTypography>
          </Grid>
          <Grid>
            <IgTypography color={theme.palette.text.secondary}>
              <br />
              Custom metrics track how many visitors in each group have
              triggered an event like a button click or page scroll at least
              once.
              <br />
              <br />
              You can use them to compare across tests or filter your results.
              Once created, you can reuse them in future tests.
            </IgTypography>
          </Grid>
        </Grid>
      </IgPaper>
    </Grid>
  );
};
